"use client";

import React from "react";
import AppLogo from "@/components/ui/AppLogo";

const Footer: React.FC = () => {
  const year = 2026;

  return (
    <footer
      className="relative px-6 py-10 overflow-hidden"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)", background: "#0D0F14" }}
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo + copyright */}
        <div className="flex items-center gap-4">
          <AppLogo size={28} />
          <span className="text-sm" style={{ color: "#5C5A56" }}>
            © {year} ElevateEmail, Inc. All rights reserved.
          </span>
        </div>

        {/* Links */}
        <div className="flex items-center gap-6 flex-wrap justify-center">
          {["Privacy Policy", "Terms of Service", "Security", "Status"].map((link) => (
            <a
              key={link}
              href="#"
              className="text-sm transition-colors duration-200"
              style={{ color: "#5C5A56" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#9B9891")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#5C5A56")}
            >
              {link}
            </a>
          ))}
        </div>

        {/* Socials */}
        <div className="flex items-center gap-4">
          {[
            {
              label: "Twitter / X",
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              ),
            },
            {
              label: "LinkedIn",
              icon: (
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6zM2 9h4v12H2z"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              ),
            },
          ].map((social) => (
            <a
              key={social.label}
              href="#"
              aria-label={social.label}
              className="transition-colors duration-200"
              style={{ color: "#5C5A56" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#F59E0B")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#5C5A56")}
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;